import React from 'react';
import styled from 'styled-components';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFacebookF, faLinkedinIn, faTwitter, faViber, faWhatsapp} from '@fortawesome/free-brands-svg-icons';
import {NAV_HEIGHT} from '../../constants';

export default function BlogShare() {
	const shareToFacebook = async () => {
		const url = document.head.querySelector('[property="og:url"]').getAttribute('content');
		const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
		window.open(shareUrl, 'facebookShare', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=500,width=600');
	};

	const shareToTwitter = async () => {
		const url = document.head.querySelector('[property="og:url"]').getAttribute('content');

		window.open(
			`https://twitter.com/share?url=${encodeURIComponent(url)}&text=${document.title}`,
			'twitterShare',
			'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=500,width=600'
		);
	};

	const shareToLinkedin = async () => {
		const url = document.head.querySelector('[property="og:url"]').getAttribute('content');

		window.open(
			`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(url)}`,
			'linkedinShare',
			'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=500,width=600'
		);
	};

	const shareToWhatsapp = async () => {
		const url = document.head.querySelector('[property="og:url"]').getAttribute('content');

		window.open(
			`https://wa.me?text=${encodeURIComponent(`${document.title}  ${url}`)}`,
			'whatsappShare',
			'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=500,width=600'
		);
	};

	const shareToViber = async () => {
		const url = document.head.querySelector('[property="og:url"]').getAttribute('content');

		window.open(
			`viber://forward?text=${encodeURIComponent(url)}`,
			'viberShare',
			'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=500,width=600'
		);
	};

	return (
		<Wrapper>
			<button type="button" className="share-facebook" title="Podijeli na Facebook" onClick={shareToFacebook}>
				<FontAwesomeIcon icon={faFacebookF} fixedWidth />
			</button>
			<button type="button" className="share-twitter" title="Podijeli na Twitter" onClick={shareToTwitter}>
				<FontAwesomeIcon icon={faTwitter} fixedWidth />
			</button>
			<button type="button" className="share-linkedin" title="Podijeli na LinkedIn" onClick={shareToLinkedin}>
				<FontAwesomeIcon icon={faLinkedinIn} fixedWidth />
			</button>
			<button type="button" className="share-whatsapp" title="Podijeli na WhatsApp" onClick={shareToWhatsapp}>
				<FontAwesomeIcon icon={faWhatsapp} fixedWidth />
			</button>
			<button type="button" className="share-viber" title="Podijeli na Viber" onClick={shareToViber}>
				<FontAwesomeIcon icon={faViber} fixedWidth />
			</button>
		</Wrapper>
	);
}

const Wrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	width: max-content;
	margin: 3rem auto;
	box-sizing: border-box;
	padding: 0;
	text-align: center;

	> button {
		display: block;
		background: none;
		border: none;
		appearance: none;
		font-size: 1.25rem;
		box-sizing: border-box;
		padding: 0.2rem;
		margin: 0.5rem;
		color: #333333;
		cursor: pointer;
		will-change: transform;
		transform: none;
		transition: transform 200ms ease-in-out;

		&.share-facebook {
			color: #4267b2;
		}

		&.share-twitter {
			color: #1da1f2;
		}

		&.share-linkedin {
			color: #0077b5;
		}

		&.share-whatsapp {
			color: #25d366;
		}

		&.share-viber {
			color: #7360f2;
		}

		@media (hover: hover) and (pointer: fine) {
			&:hover {
				transform: scale(1.4);
			}
		}

		@media (min-width: 776px) {
			&.share-viber {
				display: none;
			}
		}
	}

	@media (min-width: 992px) {
		flex-direction: column;
		float: left;
		width: calc((100vw - 800px - 4rem) / 2);
		max-width: calc(250px - 2rem);
		align-items: center;
		position: sticky;
		left: 0;
		top: calc(${NAV_HEIGHT} + 2rem);

		> button {
			margin: 0.75rem 0;
			font-size: 1.4rem;
		}
	}
`;
